import handlePowerBiAuth from "../../../util/powerBi/handlePowerBiAuth";
import CryptoJS from "crypto-js";
import { getCurrentJwt } from "../../../util/jwt/decryptToken";

export async function queryDashboardLinks(userPrompt, clientName, signal) {
  const token = getCurrentJwt()
  const workspace_id = CryptoJS.AES.decrypt(
    localStorage.getItem("powerBiWorkspaceId"),
    process.env.REACT_APP_PASS
  ).toString(CryptoJS.enc.Utf8)

  const options = {
    method: "POST",
    headers: {
      Authorization: token
    },
    signal: signal,
    body: JSON.stringify({
      question: userPrompt,
      access_token: await handlePowerBiAuth(token),
      workspace_id: workspace_id,
      client_name: clientName
    }),
  };
  let sleepTime = 1000
  let res = null

  const testAbort1 = new RegExp(".*AbortError: signal is aborted without reason.*")
  const testAbort2 = new RegExp(".*The operation was aborted.*")
  const testAbort3 = new RegExp(".*aborted.*")

  while (true) {
    sleepTime *= 2
    try {
      res = await fetch(process.env.REACT_APP_API +"/orion/reporting-guide", options)
      if(res.status === 200) {
        res = await res.json()
        if (res.hasOwnProperty('message') && res.hasOwnProperty('reports')) {
          return res
        }
      }
    }
    catch (e) {
      // Handle Abort
      if(testAbort1.test(e.toString()) || testAbort2.test(e.toString()) || testAbort3.test(e.toString())) {
        return {"isAborted": 'YES'}
      }
      console.log(e)
    }
    await new Promise(resolve => setTimeout(resolve, sleepTime));
  }
}


// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageUtil/queryDashboardLinks.js